export default {
  accepting:
    "Be sure to be right before accepting, as this action will distribute cost across orders in grouped linehauls.",
  "change-count": "You are about to group { count } linehauls",
  "success-count": "{ count } linehauls were succesfully grouped",
  "total-cost-grouped":
    "The total cost of the grouped linehauls will be summed and evenly distributed across all associated orders.",
};
